import React from "react";

function ContactPage() {
  return (
    <section className="max-w-3xl mx-auto px-4 py-12 text-center font-sans text-slate-800">
      <h1 className="text-4xl font-extrabold text-slate-900 mb-8">Kontakt</h1>
      <div className="bg-white p-8 rounded-xl border border-slate-200 shadow-sm max-w-xl mx-auto">
        <p className="text-lg leading-relaxed text-slate-700 mb-6">
          Sie erreichen mich am besten per E-Mail unter{" "}
          <a href="mailto:info@simonaltschaeffl.de" className="text-blue-600 hover:text-blue-800 font-medium hover:underline">
            info@simonaltschaeffl.de
          </a>{" "}
          <br /> oder per Telefon unter{" "}
          <a href="tel:+4915157852478" className="text-blue-600 hover:text-blue-800 font-medium hover:underline">+49 1515 7852478</a>. <br />
        </p>
        <p className="text-slate-600 p-4 bg-slate-50 rounded-lg border border-slate-100 text-sm">
          <em className="font-semibold not-italic text-slate-800">Bitte beachten Sie</em>, dass es w&auml;hrend meiner Schulzeiten zu <br />
          Verz&ouml;gerungen bei der Beantwortung kommen kann. Ich bem&uuml;he mich <br />
          jedoch, Ihre Anfrage <b>so schnell wie m&ouml;glich</b> zu beantworten.
        </p>
      </div>
    </section>
  );
}

export default ContactPage;